import axios from 'axios';
import { RefreshOtp } from "./endpoints";

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
    failedQueue.forEach(p => error ? p.reject(error) : p.resolve(token));
    failedQueue = [];
};

export const attemptTokenRefresh = async () => {
    if (isRefreshing) {
        return new Promise((resolve, reject) => {
            failedQueue.push({ resolve, reject });
        });
    }

    isRefreshing = true;

    try {
        const refreshResult = await axios.post(RefreshOtp, {}, { withCredentials: true });
        const newToken = refreshResult.data.data.token;
        document.cookie = `token=${newToken}; Secure; SameSite=Strict; path=/;`;
        processQueue(null, newToken);
        return newToken;
    } catch (error) {
        processQueue(error, null);
        sessionStorage.setItem('logout_reason', 'session_expired');
        document.cookie = `token=; Secure; SameSite=Strict; path=/; max-age=0`;
        localStorage.removeItem('isLoggedIn');
        window.location.href = '/login';
        throw error;
    } finally {
        isRefreshing = false;
    }
};